import { actionModels } from './actionModels.js';

const APPLICATION_CLASS_FALLBACK_PARENT_CATEGORY = 'Other';
const loggedMissingParentCategoryValues = new Set();

export const applicationClassParentCategoryOrder = ['Communication', 'Productivity', 'IT Operations', 'Sales & CRM', 'Commerce', 'Marketing', 'Content & Files', 'Support', 'Human Resources', 'Business Intelligence', 'Artificial Intelligence', 'Website & App Building', APPLICATION_CLASS_FALLBACK_PARENT_CATEGORY];

const applicationClassParentCategoriesByValue = {
  hris: 'Human Resources',
  accounting: 'Commerce',
  commerce: 'Commerce',
  crm: 'Sales & CRM',
  dataExtraction: 'Business Intelligence',
  marketing: 'Marketing',
  teamMessaging: 'Communication',
  recruiting: 'Human Resources',
  storage: 'Content & Files',
  ticketing: 'Support'
};

const getApplicationClassParentCategory = (value) => {
  const parentCategory = applicationClassParentCategoriesByValue[value];

  if (!parentCategory) {
    if (!loggedMissingParentCategoryValues.has(value)) {
      loggedMissingParentCategoryValues.add(value);
      console.warn(`Application class ${value} is missing parentCategory; using ${APPLICATION_CLASS_FALLBACK_PARENT_CATEGORY}.`);
    }

    return APPLICATION_CLASS_FALLBACK_PARENT_CATEGORY;
  }

  return parentCategory;
};

const appModel = Object.entries(actionModels).reduce((acc, [key, value]) => {
  if (!key.includes('.')) {
    return acc;
  }

  const [category] = key.split('.');
  if (!acc[category]) {
    acc[category] = { label: value.label.split(' / ')[0], value: category, parentCategory: getApplicationClassParentCategory(category) };
  }
  return acc;
}, {});

const additiveApplicationClassOptions = [
  { label: 'Developer Tools', value: 'developerTools', parentCategory: 'IT Operations' },
  { label: 'DevOps', value: 'devOps', parentCategory: 'IT Operations' },
  { label: 'Project Management', value: 'projectManagement', parentCategory: 'Productivity' },
  { label: 'Knowledge Management', value: 'knowledgeManagement', parentCategory: 'Productivity' },
  { label: 'Analytics & BI', value: 'analyticsBi', parentCategory: 'Business Intelligence' },
  { label: 'Data Warehouse', value: 'dataWarehouse', parentCategory: 'Business Intelligence' },
  { label: 'Database', value: 'database', parentCategory: 'IT Operations' },
  { label: 'Integration & Automation', value: 'integrationAutomation', parentCategory: 'IT Operations' },
  { label: 'IT Service Management', value: 'itServiceManagement', parentCategory: 'IT Operations' },
  { label: 'Observability', value: 'observability', parentCategory: 'IT Operations' },
  { label: 'Security & Identity', value: 'securityIdentity', parentCategory: 'IT Operations' },
  { label: 'Security & Compliance', value: 'securityCompliance', parentCategory: 'IT Operations' },
  { label: 'ERP', value: 'erp', parentCategory: 'Commerce' },
  { label: 'Payments & Billing', value: 'paymentsBilling', parentCategory: 'Commerce' },
  { label: 'Procurement', value: 'procurement', parentCategory: 'Commerce' },
  { label: 'Supply Chain', value: 'supplyChain', parentCategory: 'Commerce' },
  { label: 'Legal & Contracts', value: 'legalContracts', parentCategory: 'Productivity' },
  { label: 'CMS', value: 'cms', parentCategory: 'Website & App Building' },
  { label: 'Social Media', value: 'socialMedia', parentCategory: 'Marketing' },
  { label: 'Advertising', value: 'advertising', parentCategory: 'Marketing' },
  { label: 'Email Communications', value: 'communicationsEmail', parentCategory: 'Communication' },
  { label: 'Video Communications', value: 'communicationsVideo', parentCategory: 'Communication' },
  { label: 'Contact Center', value: 'contactCenter', parentCategory: 'Support' },
  { label: 'Customer Success', value: 'customerSuccess', parentCategory: 'Support' },
  { label: 'Forms & Surveys', value: 'formsSurveys', parentCategory: 'Productivity' },
  { label: 'Scheduling', value: 'scheduling', parentCategory: 'Productivity' },
  { label: 'Events & Webinars', value: 'eventsWebinars', parentCategory: 'Marketing' },
  { label: 'Learning (LMS)', value: 'learningLms', parentCategory: 'Human Resources' },
  { label: 'Field Service', value: 'fieldService', parentCategory: 'Support' },
  { label: 'AI / ML', value: 'aiMl', parentCategory: 'Artificial Intelligence' }
];

const appModelOptionsByValue = Object.values(appModel).reduce((acc, option) => {
  acc.set(option.value, option);
  return acc;
}, new Map());

for (const option of additiveApplicationClassOptions) {
  if (!appModelOptionsByValue.has(option.value)) {
    appModelOptionsByValue.set(option.value, option);
  }
}

export const appModelOptions = Array.from(appModelOptionsByValue.values());
